import axios from 'axios';
import URLs from '@/config/constants';

// eslint-disable-next-line import/prefer-default-export
export const validateBeneficiary = ({ rut }) => axios.get(`${URLs.GetValidateBeneficiary}rutBeneficiary=${rut}`);
